import { createContext } from "react";
export const EditorStoreContext = createContext(null);
